import { combineEpics } from "redux-observable";
import { featureRolloutLogPerformanceEpics } from "./actions/FeatureRolloutLogPerformanceEpics.js";
import { e as epics, a as epics$1 } from "../FeatureDataActions-59549dc8.js";
import expAlertEpics from "@ane/expalert/lib/module/epics";
import { epics as epics$2 } from "@ane/progression-scorecard-app-module/lib/module/views/AnalysisTemplate/ProgressionScorecard/ProgressionScorecard.ducks";
import { submitFormSubscribersEpic } from "./views/rolloutUI/header/FeatureNotificationPicker.js";
const rootEpic = combineEpics(
  epics,
  epics$1,
  expAlertEpics,
  featureRolloutLogPerformanceEpics,
  epics$2,
  submitFormSubscribersEpic
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
